import { Helmet } from 'react-helmet-async';

export default function SEO({
  title,
  description,
  canonical,
  ogImage = 'https://www.invilic.com/og-image.png',
  ogType = 'website',
  noindex = false,
  schema = null,
}) {
  const fullTitle = title.includes('Invilic') ? title : `${title} | Invilic`;
  const canonicalUrl = canonical || 'https://www.invilic.com/';

  // Auto-inject BreadcrumbList for all blog article pages
  let breadcrumbSchema = null;
  if (ogType === 'article' && canonicalUrl.includes('/blog/')) {
    breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': [
        { '@type': 'ListItem', 'position': 1, 'name': 'Home', 'item': 'https://www.invilic.com' },
        { '@type': 'ListItem', 'position': 2, 'name': 'Blog', 'item': 'https://www.invilic.com/blog' },
        { '@type': 'ListItem', 'position': 3, 'name': title.replace(' | Invilic', '').replace(' | Invilic Blog', ''), 'item': canonicalUrl },
      ],
    };
  }

  return (
    <Helmet>
      {/* These are the ONLY place these tags should exist — index.html has none */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />

      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {/* llms-full.txt for AI systems that want expanded content */}
      {ogType === 'article' && (
        <link rel="alternate" type="text/plain" href="https://www.invilic.com/llms-full.txt" title="Full LLM-readable content" />
      )}

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
      {breadcrumbSchema && (
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      )}
    </Helmet>
  );
}
